import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
  InsightDataItem,
} from '../InsightDataPayload';

export interface CapacityManagementResourceWorkloadDataItem
  extends InsightDataItem {
  date: string;
  demand_hours: number;
  capacity_hours: number;
  allocated_hours: number;
  scheduled_hours: number;
  available_hours: number;
}

export interface CapacityManagementResourceWorkloadOverviewPayload
  extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW;
    id: string;
    attributes: {
      data: Array<CapacityManagementResourceWorkloadDataItem>;
    };
  };
}

export const parseCapacityManagementResourceWorkloadOverviewPayload = (
  payload: BaseInsightPayload
): CapacityManagementResourceWorkloadOverviewPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<CapacityManagementResourceWorkloadDataItem>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_RESOURCE_WORKLOAD_OVERVIEW,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
